import { useStorage } from "opendash";

export function useCart() {
  return useStorage<[string, number][]>("user", "recipes:cart", []);
}
